import { CContainer } from '@coreui/react'
import React from 'react'

const Footer = () => {
    return (
        <div className='wizard-footer' >
            <CContainer>
                <div className='address-box' >
                    <h2>ارتباط با ما</h2>
                    <address>
                        تلفن تماس: ۲۸۴۲۰ ۰۲۱
                        <br />
                        ایمیل: <a href="mailto:info@daftareshoma.com">info@daftareshoma.com</a>
                    </address>

                </div>

            </CContainer>
            <div className='bottom-context'>
                <CContainer>
                    2016 © DaftareShoma
                </CContainer>



            </div>
        </div>
    )
}

export default Footer
